// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Root ───────────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-root {
  width: 100%;
  max-width: 1920px;
  padding: 10px 130px 20px 130px;
  box-sizing: border-box;
  font-family: 'Inter', sans-serif;
}

/* ─── Loading skeleton ───────────────────────────────────────────────────────── */
.scl--cms-content-edit-skeleton-wrap {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 24px;
}

@keyframes scl--cms-content-edit-shimmer {
  0%   { background-position: 100% 50%; }
  100% { background-position:   0% 50%; }
}

.scl--cms-content-edit-skeleton {
  border-radius: 4px;
  background: linear-gradient(90deg, #F1F3F7 25%, #E8EBF0 50%, #F1F3F7 75%);
  background-size: 400% 100%;
  animation: scl--cms-content-edit-shimmer 1.4s ease infinite;
}
.scl--cms-content-edit-skeleton--title { height: 40px; width: 280px; }
.scl--cms-content-edit-skeleton--desc  { height: 20px; width: 460px; margin-bottom: 8px; }
.scl--cms-content-edit-skeleton--field { height: 44px; width: 100%; }

/* ─── Empty / error state ────────────────────────────────────────────────────── */
.scl--cms-content-edit-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 8px;
  text-align: center;
}
.scl--cms-content-edit-empty-title { font-size: 18px; font-weight: 600; color: #323539; margin: 0; }
.scl--cms-content-edit-empty-desc  { font-size: 14px; color: #8A8B8F; margin: 0 0 16px; }

/* ─── Breadcrumb ─────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-breadcrumb { display: flex; align-items: center; gap: 6px; margin-bottom: 14px; }
.scl--cms-content-edit-breadcrumb-item {
  display: flex; align-items: center; gap: 5px;
  font-size: 12px; color: #8A8B8F;
}

/* ─── Page heading ───────────────────────────────────────────────────────────── */
.scl--cms-content-edit-page-title { margin: 0 0 6px; font-size: 36px; font-weight: 600; line-height: 40px; color: #323539; }
.scl--cms-content-edit-page-desc  { margin: 0 0 28px; font-size: 16px; line-height: 24px; color: #8A8B8F; letter-spacing: -0.01em; }

/* ─── Meta grid ──────────────────────────────────────────────────────────────── */
/*
  2-column grid. TextField / SelectField components fill cells naturally.
  Status (5th child) is pinned to the left column.
*/
.scl--cms-content-edit-meta-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 24px;
  margin-bottom: 32px;
}
.scl--cms-content-edit-meta-grid > *:nth-child(5) { grid-column: 1; }

.scl--cms-content-edit-section-heading {
  font-size: 16px; font-weight: 600; color: #323539; margin: 0 0 10px;
}
.scl--cms-content-edit-divider {
  height: 1px; background: #E1E4ED; margin-bottom: 20px;
}

/* ─── Field label row ────────────────────────────────────────────────────────── */
.scl--cms-content-edit-field-label-row {
  display: flex; align-items: center; justify-content: space-between;
  margin-top: 16px; margin-bottom: 8px;
}
.scl--cms-content-edit-field-label { font-size: 14px; color: #323539; font-weight: 400; }
.scl--cms-content-edit-required    { color: #FF4D4F; }

/* ─── SplitRow ───────────────────────────────────────────────────────────────── */
/*
  ┌────────────────────────────────────────────────────────────┐
  │ ▌  saved / current text (left)  │  [input component] (right)│
  └────────────────────────────────────────────────────────────┘
*/
.scl--cms-content-edit-split-row {
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 60px;
  background: #FDFDFD;
  border: 1px dashed rgba(208, 213, 221, 0.3);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 4px;
}
.scl--cms-content-edit-split-row--multiline {
  min-height: 96px;
  align-items: flex-start;
}

/* Green left accent bar */
.scl--cms-content-edit-split-accent {
  width: 4px;
  flex-shrink: 0;
  background: #84A578;
  border-radius: 0 0 2px 2px;
  align-self: stretch;
}

/* Row body */
.scl--cms-content-edit-split-body {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px 0 16px;
  gap: 12px;
  min-height: 60px;
}
.scl--cms-content-edit-split-row--multiline .scl--cms-content-edit-split-body {
  align-items: flex-start;
  padding-top: 14px;
  padding-bottom: 14px;
  min-height: 96px;
}

/* Saved / current value — left */
.scl--cms-content-edit-split-current-text {
  flex: 1;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.8);
  word-break: break-word;
}

/* Input component slot — right */
.scl--cms-content-edit-split-input-slot {
  flex-shrink: 0;
  width: 240px;
}

/* Let component-level containers fill the slot */
.scl--cms-content-edit-split-input-slot .scl--cms-components-textField-container,
.scl--cms-content-edit-split-input-slot .scl--cms-components-textArea-container {
  width: 100%;
}

/* ─── Card selector (list fields) ────────────────────────────────────────────── */
.scl--cms-content-edit-card-selector-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  overflow: visible;
  position: relative;
  z-index: 10;
  margin-top: 16px;
  margin-bottom: 12px;
}
.scl--cms-content-edit-card-selector-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  overflow: visible;
  position: relative;
  z-index: 10;
}

/* Keep the Toggle component from breaking out of the row */
.scl--cms-content-edit-card-selector-right > *:last-child {
  flex-shrink: 0;
}
.scl--cms-content-edit-list-block { margin-bottom: 4px; }

/* Compact SelectField inside card selector */
.scl--cms-content-edit-card-select .scl--cms-components-selectField-container,
.scl--cms-content-edit-card-select { min-width: 200px; }

/* ─── Image upload ───────────────────────────────────────────────────────────── */
.scl--cms-content-edit-upload-block { margin-bottom: 4px; }

/* Outer card — full width dashed border, matches design spec 431×75 */
.scl--cms-content-edit-upload-row {
  box-sizing: border-box;
  width: 100%;
  min-height: 75px;
  background: #FFFFFF;
  border: 1px dashed #D0D5DD;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
}

/* Left — icon + meta content */
.scl--cms-content-edit-upload-current {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 0 16px;
  width: 100%;
  min-height: 75px;
  background: #FFFFFF;
}

/* Icon avatar — 40×40 rounded box with border */
.scl--cms-content-edit-upload-thumb {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  border: 0.5px solid #D0D5DD;
  object-fit: contain;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Meta — filename + size stacked */
.scl--cms-content-edit-upload-meta {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 6px;
}

.scl--cms-content-edit-upload-name {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #323539;
}

.scl--cms-content-edit-upload-size {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 8px;
  line-height: 22px;
  color: #8A8B8F;
}

.scl--cms-content-edit-upload-empty { font-size: 13px; color: #C1C5CE; }
/* FileUpload component used as upload zone — override to fit inside .scl--cms-content-edit-upload-row */
.scl--cms-content-edit-upload-zone.scl--cms-components-fileUpload-container {
  width: 100%;
  box-sizing: border-box;
  border-top: 1px dashed #D0D5DD;
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-radius: 0;
}

/* ─── Service / icon sub-items ───────────────────────────────────────────────── */
.scl--cms-content-edit-service-items { margin-top: 4px; }
.scl--cms-content-edit-service-block { margin-bottom: 4px; }

/* Full-width flex row inside split slot for service entries */
.scl--cms-content-edit-service-cell {
  display: flex; align-items: center;
  justify-content: space-between; width: 100%; gap: 12px;
}
.scl--cms-content-edit-service-left {
  display: flex; align-items: center; gap: 10px; flex: 1; min-width: 0;
}
.scl--cms-content-edit-service-icon {
  width: 32px; height: 32px; object-fit: contain;
  border-radius: 4px; flex-shrink: 0;
}
.scl--cms-content-edit-service-icon-placeholder {
  width: 32px; height: 32px; background: #F1F3F7; border-radius: 4px; flex-shrink: 0;
}
.scl--cms-content-edit-service-label { font-size: 13px; font-weight: 500; color: #323539; }
.scl--cms-content-edit-service-size  { font-size: 11px; color: #8A8B8F; margin-top: 2px; }

/* TextField inside service row — compact width */
.scl--cms-content-edit-service-cell .scl--cms-components-textField-container {
  width: 200px; flex-shrink: 0;
}

/* ─── Footer actions ─────────────────────────────────────────────────────────── */
.scl--cms-content-edit-actions {
  display: flex; justify-content: flex-end;
  gap: 12px;  padding-top: 24px;
}

/* ─── Textarea fixed width 351px ────────────────────────────────────────────── */
.scl--cms-content-edit-split-input-slot--textarea {
  width: 351px;
}
.scl--cms-content-edit-split-input-slot--textarea .scl--cms-components-textArea-container,
.scl--cms-content-edit-split-input-slot--textarea .scl--cms-components-textArea-plate,
.scl--cms-content-edit-split-input-slot--textarea textarea {
  width: 351px !important;
  box-sizing: border-box;
}

/* Scrollable textarea — fixed height with vertical scrollbar when content overflows */
.scl--cms-content-edit-split-input-slot--textarea textarea {
  max-height: 96px;
  overflow-y: auto;
  resize: none;
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/content/edit-content/default-edit-page/css/contentSectionEditPage.css"],"names":[],"mappings":"AAAA,mFAAmF;AACnF;EACE,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,mFAAmF;AACnF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,OAAO,6BAA6B,EAAE;EACtC,OAAO,6BAA6B,EAAE;AACxC;;AAEA;EACE,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,2DAA2D;AAC7D;AACA,yCAAyC,YAAY,EAAE,YAAY,EAAE;AACrE,yCAAyC,YAAY,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACzF,yCAAyC,YAAY,EAAE,WAAW,EAAE;;AAEpE,mFAAmF;AACnF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,QAAQ;EACR,kBAAkB;AACpB;AACA,qCAAqC,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE;AACnG,qCAAqC,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;;AAExF,mFAAmF;AACnF,oCAAoC,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACvG;EACE,aAAa,EAAE,mBAAmB,EAAE,QAAQ;EAC5C,eAAe,EAAE,cAAc;AACjC;;AAEA,mFAAmF;AACnF,oCAAoC,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAC3H,oCAAoC,gBAAgB,EAAE,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE,uBAAuB,EAAE;;AAEnI,mFAAmF;AACnF;;;CAGC;AACD;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;AACA,oDAAoD,cAAc,EAAE;;AAEpE;EACE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,gBAAgB;AACrE;AACA;EACE,WAAW,EAAE,mBAAmB,EAAE,mBAAmB;AACvD;;AAEA,mFAAmF;AACnF;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,gBAAgB,EAAE,kBAAkB;AACtC;AACA,qCAAqC,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACxF,qCAAqC,cAAc,EAAE;;AAErD,mFAAmF;AACnF;;;;CAIC;AACD;EACE,sBAAsB;EACtB,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,OAAO;EACP,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,YAAY;AACd;;AAEA,iDAAiD;AACjD;;EAEE,WAAW;AACb;;AAEA,mFAAmF;AACnF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA,2DAA2D;AAC3D;EACE,cAAc;AAChB;AACA,oCAAoC,kBAAkB,EAAE;;AAExD,6CAA6C;AAC7C;qCACqC,gBAAgB,EAAE;;AAEvD,mFAAmF;AACnF,sCAAsC,kBAAkB,EAAE;;AAE1D,sEAAsE;AACtE;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sCAAsC,eAAe,EAAE,cAAc,EAAE;AACvE,wGAAwG;AACxG;EACE,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mFAAmF;AACnF,uCAAuC,eAAe,EAAE;AACxD,uCAAuC,kBAAkB,EAAE;;AAE3D,8DAA8D;AAC9D;EACE,aAAa,EAAE,mBAAmB;EAClC,8BAA8B,EAAE,WAAW,EAAE,SAAS;AACxD;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,OAAO,EAAE,YAAY;AACtE;AACA;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB;EAC9C,kBAAkB,EAAE,cAAc;AACpC;AACA;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,cAAc;AACpF;AACA,uCAAuC,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC1F,uCAAuC,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEzF,iDAAiD;AACjD;EACE,YAAY,EAAE,cAAc;AAC9B;;AAEA,mFAAmF;AACnF;EACE,aAAa,EAAE,yBAAyB;EACxC,SAAS,GAAG,iBAAiB;AAC/B;;AAEA,kFAAkF;AAClF;EACE,YAAY;AACd;AACA;;;EAGE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,sFAAsF;AACtF;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd","sourcesContent":["/* ─── Root ───────────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-root {\n  width: 100%;\n  max-width: 1920px;\n  padding: 10px 130px 20px 130px;\n  box-sizing: border-box;\n  font-family: 'Inter', sans-serif;\n}\n\n/* ─── Loading skeleton ───────────────────────────────────────────────────────── */\n.scl--cms-content-edit-skeleton-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-top: 24px;\n}\n\n@keyframes scl--cms-content-edit-shimmer {\n  0%   { background-position: 100% 50%; }\n  100% { background-position:   0% 50%; }\n}\n\n.scl--cms-content-edit-skeleton {\n  border-radius: 4px;\n  background: linear-gradient(90deg, #F1F3F7 25%, #E8EBF0 50%, #F1F3F7 75%);\n  background-size: 400% 100%;\n  animation: scl--cms-content-edit-shimmer 1.4s ease infinite;\n}\n.scl--cms-content-edit-skeleton--title { height: 40px; width: 280px; }\n.scl--cms-content-edit-skeleton--desc  { height: 20px; width: 460px; margin-bottom: 8px; }\n.scl--cms-content-edit-skeleton--field { height: 44px; width: 100%; }\n\n/* ─── Empty / error state ────────────────────────────────────────────────────── */\n.scl--cms-content-edit-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  gap: 8px;\n  text-align: center;\n}\n.scl--cms-content-edit-empty-title { font-size: 18px; font-weight: 600; color: #323539; margin: 0; }\n.scl--cms-content-edit-empty-desc  { font-size: 14px; color: #8A8B8F; margin: 0 0 16px; }\n\n/* ─── Breadcrumb ─────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-breadcrumb { display: flex; align-items: center; gap: 6px; margin-bottom: 14px; }\n.scl--cms-content-edit-breadcrumb-item {\n  display: flex; align-items: center; gap: 5px;\n  font-size: 12px; color: #8A8B8F;\n}\n\n/* ─── Page heading ───────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-page-title { margin: 0 0 6px; font-size: 36px; font-weight: 600; line-height: 40px; color: #323539; }\n.scl--cms-content-edit-page-desc  { margin: 0 0 28px; font-size: 16px; line-height: 24px; color: #8A8B8F; letter-spacing: -0.01em; }\n\n/* ─── Meta grid ──────────────────────────────────────────────────────────────── */\n/*\n  2-column grid. TextField / SelectField components fill cells naturally.\n  Status (5th child) is pinned to the left column.\n*/\n.scl--cms-content-edit-meta-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px 24px;\n  margin-bottom: 32px;\n}\n.scl--cms-content-edit-meta-grid > *:nth-child(5) { grid-column: 1; }\n\n.scl--cms-content-edit-section-heading {\n  font-size: 16px; font-weight: 600; color: #323539; margin: 0 0 10px;\n}\n.scl--cms-content-edit-divider {\n  height: 1px; background: #E1E4ED; margin-bottom: 20px;\n}\n\n/* ─── Field label row ────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-field-label-row {\n  display: flex; align-items: center; justify-content: space-between;\n  margin-top: 16px; margin-bottom: 8px;\n}\n.scl--cms-content-edit-field-label { font-size: 14px; color: #323539; font-weight: 400; }\n.scl--cms-content-edit-required    { color: #FF4D4F; }\n\n/* ─── SplitRow ───────────────────────────────────────────────────────────────── */\n/*\n  ┌────────────────────────────────────────────────────────────┐\n  │ ▌  saved / current text (left)  │  [input component] (right)│\n  └────────────────────────────────────────────────────────────┘\n*/\n.scl--cms-content-edit-split-row {\n  box-sizing: border-box;\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  min-height: 60px;\n  background: #FDFDFD;\n  border: 1px dashed rgba(208, 213, 221, 0.3);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 4px;\n}\n.scl--cms-content-edit-split-row--multiline {\n  min-height: 96px;\n  align-items: flex-start;\n}\n\n/* Green left accent bar */\n.scl--cms-content-edit-split-accent {\n  width: 4px;\n  flex-shrink: 0;\n  background: #84A578;\n  border-radius: 0 0 2px 2px;\n  align-self: stretch;\n}\n\n/* Row body */\n.scl--cms-content-edit-split-body {\n  flex: 1;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 12px 0 16px;\n  gap: 12px;\n  min-height: 60px;\n}\n.scl--cms-content-edit-split-row--multiline .scl--cms-content-edit-split-body {\n  align-items: flex-start;\n  padding-top: 14px;\n  padding-bottom: 14px;\n  min-height: 96px;\n}\n\n/* Saved / current value — left */\n.scl--cms-content-edit-split-current-text {\n  flex: 1;\n  font-size: 16px;\n  line-height: 22px;\n  color: rgba(0, 0, 0, 0.8);\n  word-break: break-word;\n}\n\n/* Input component slot — right */\n.scl--cms-content-edit-split-input-slot {\n  flex-shrink: 0;\n  width: 240px;\n}\n\n/* Let component-level containers fill the slot */\n.scl--cms-content-edit-split-input-slot .scl--cms-components-textField-container,\n.scl--cms-content-edit-split-input-slot .scl--cms-components-textArea-container {\n  width: 100%;\n}\n\n/* ─── Card selector (list fields) ────────────────────────────────────────────── */\n.scl--cms-content-edit-card-selector-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: visible;\n  position: relative;\n  z-index: 10;\n  margin-top: 16px;\n  margin-bottom: 12px;\n}\n.scl--cms-content-edit-card-selector-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  overflow: visible;\n  position: relative;\n  z-index: 10;\n}\n\n/* Keep the Toggle component from breaking out of the row */\n.scl--cms-content-edit-card-selector-right > *:last-child {\n  flex-shrink: 0;\n}\n.scl--cms-content-edit-list-block { margin-bottom: 4px; }\n\n/* Compact SelectField inside card selector */\n.scl--cms-content-edit-card-select .scl--cms-components-selectField-container,\n.scl--cms-content-edit-card-select { min-width: 200px; }\n\n/* ─── Image upload ───────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-upload-block { margin-bottom: 4px; }\n\n/* Outer card — full width dashed border, matches design spec 431×75 */\n.scl--cms-content-edit-upload-row {\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 75px;\n  background: #FFFFFF;\n  border: 1px dashed #D0D5DD;\n  border-radius: 10px;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n/* Left — icon + meta content */\n.scl--cms-content-edit-upload-current {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n  padding: 0 16px;\n  width: 100%;\n  min-height: 75px;\n  background: #FFFFFF;\n}\n\n/* Icon avatar — 40×40 rounded box with border */\n.scl--cms-content-edit-upload-thumb {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  border: 0.5px solid #D0D5DD;\n  object-fit: contain;\n  background: #FFFFFF;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Meta — filename + size stacked */\n.scl--cms-content-edit-upload-meta {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.scl--cms-content-edit-upload-name {\n  font-family: 'Inter', sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #323539;\n}\n\n.scl--cms-content-edit-upload-size {\n  font-family: 'Inter', sans-serif;\n  font-weight: 400;\n  font-size: 8px;\n  line-height: 22px;\n  color: #8A8B8F;\n}\n\n.scl--cms-content-edit-upload-empty { font-size: 13px; color: #C1C5CE; }\n/* FileUpload component used as upload zone — override to fit inside .scl--cms-content-edit-upload-row */\n.scl--cms-content-edit-upload-zone.scl--cms-components-fileUpload-container {\n  width: 100%;\n  box-sizing: border-box;\n  border-top: 1px dashed #D0D5DD;\n  border-left: none;\n  border-right: none;\n  border-bottom: none;\n  border-radius: 0;\n}\n\n/* ─── Service / icon sub-items ───────────────────────────────────────────────── */\n.scl--cms-content-edit-service-items { margin-top: 4px; }\n.scl--cms-content-edit-service-block { margin-bottom: 4px; }\n\n/* Full-width flex row inside split slot for service entries */\n.scl--cms-content-edit-service-cell {\n  display: flex; align-items: center;\n  justify-content: space-between; width: 100%; gap: 12px;\n}\n.scl--cms-content-edit-service-left {\n  display: flex; align-items: center; gap: 10px; flex: 1; min-width: 0;\n}\n.scl--cms-content-edit-service-icon {\n  width: 32px; height: 32px; object-fit: contain;\n  border-radius: 4px; flex-shrink: 0;\n}\n.scl--cms-content-edit-service-icon-placeholder {\n  width: 32px; height: 32px; background: #F1F3F7; border-radius: 4px; flex-shrink: 0;\n}\n.scl--cms-content-edit-service-label { font-size: 13px; font-weight: 500; color: #323539; }\n.scl--cms-content-edit-service-size  { font-size: 11px; color: #8A8B8F; margin-top: 2px; }\n\n/* TextField inside service row — compact width */\n.scl--cms-content-edit-service-cell .scl--cms-components-textField-container {\n  width: 200px; flex-shrink: 0;\n}\n\n/* ─── Footer actions ─────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-actions {\n  display: flex; justify-content: flex-end;\n  gap: 12px;  padding-top: 24px;\n}\n\n/* ─── Textarea fixed width 351px ────────────────────────────────────────────── */\n.scl--cms-content-edit-split-input-slot--textarea {\n  width: 351px;\n}\n.scl--cms-content-edit-split-input-slot--textarea .scl--cms-components-textArea-container,\n.scl--cms-content-edit-split-input-slot--textarea .scl--cms-components-textArea-plate,\n.scl--cms-content-edit-split-input-slot--textarea textarea {\n  width: 351px !important;\n  box-sizing: border-box;\n}\n\n/* Scrollable textarea — fixed height with vertical scrollbar when content overflows */\n.scl--cms-content-edit-split-input-slot--textarea textarea {\n  max-height: 96px;\n  overflow-y: auto;\n  resize: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
